import React, { useContext, createContext, useState, FC, Dispatch, SetStateAction } from 'react';
import { IEventDetail } from '../event/eventInterface';

export interface IEventContext {
  eventDetails: IEventDetail | null | undefined;
  setEventDetails: Dispatch<SetStateAction<IEventDetail | undefined | null>>;
}

export const EventContext = createContext<IEventContext>({} as any);
const EventWrapper: FC = ({ children }) => {
  const [eventDetails, setEventDetails] = useState<IEventDetail | undefined | null>(
    undefined as any,
  );
  return (
    <EventContext.Provider value={{ eventDetails, setEventDetails }}>
      {children}
    </EventContext.Provider>
  );
};
const useEventContext = () => useContext<IEventContext>(EventContext);

export { EventWrapper, useEventContext };
